import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tKgpco/Store/CustomHandlerCreator";

type HandlerType = CustomHandler<{
    isAllRolesSelected: boolean;
}>;

export const DispatchSelectedAllRoles: HandlerType = props => {
    props.dispatch({
        type: "Custom/SecurityRoles/SelectedAllRoles",
        isAllRolesSelected: props.parameter.isAllRolesSelected,
    });
};

export const chain = [DispatchSelectedAllRoles];

const selectAllRoles = createHandlerChainRunner(chain, "selectAllRoles");
export default selectAllRoles;
